var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 2.16602C5.40484 2.16602 1.6665 5.90435 1.6665 10.4993C1.6665 15.0943 5.40484 18.8327 9.99984 18.8327C14.5948 18.8327 18.3332 15.0943 18.3332 10.4993C18.3332 5.90435 14.5948 2.16602 9.99984 2.16602ZM9.99984 17.166C6.324 17.166 3.33317 14.1752 3.33317 10.4993C3.33317 6.82352 6.324 3.83268 9.99984 3.83268C13.6757 3.83268 16.6665 6.82352 16.6665 10.4993C16.6665 14.1752 13.6757 17.166 9.99984 17.166Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8H12.5V13H7.5V8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.9ff5c6f31ab38bfae2b6ee70e3aaa9a2.svg";
export { ForwardRef as ReactComponent };